// removed by extract-text-webpack-plugin
module.exports = {"Container":"errorBoundary__Container__1NPF-","Message":"errorBoundary__Message__2vxlz"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/errorBoundary/errorBoundary.css
// module id = 176
// module chunks = 2